import { create } from "zustand";

interface ReactRenderStore {
  selectedElement: {
    props: Record<string, any>;
    file: string | null;
    line: number | null;
    column: number | null;
    childText: string | null;
    top: number;
    left: number;
    right: number;
    bottom: number;
    width: number;
    height: number;
    styleOverrides: Record<string, string>;
  } | null;
  setSelectedElement: (
    selectedElement: {
      props: Record<string, any>;
      file: string | null;
      line: number | null;
      column: number | null;
      childText: string | null;
      top: number;
      left: number;
      right: number;
      bottom: number;
      width: number;
      height: number;
      styleOverrides: Record<string, string>;
    } | null,
  ) => void;

  editText: string | null;
  setEditText: (editText: string | null) => void;

  classNames: string;
  setClassNames: (classNames: string) => void;

  displayMode: "interactive" | "select";
  toggleDisplayMode: () => void;

  sectionClicked: boolean;
  setSectionClicked: (sectionClicked: boolean) => void;

  contextMenuOpen: boolean;
  setContextMenuOpen: (open: boolean) => void;

  resetToDefaults: () => void;

  viewingVersionId: string | null;
  setViewingVersionId: (viewingVersionId: string | null) => void;
}

export const useReactRenderStore = create<ReactRenderStore>((set, get) => ({
  selectedElement: null,
  setSelectedElement: (selectedElement) =>
    set((state) => ({
      selectedElement:
        state.displayMode === "interactive" ? null : selectedElement,
    })),

  editText: null,
  setEditText: (editText) => set({ editText }),

  classNames: "",
  setClassNames: (classNames) => {
    set({ classNames });
  },

  displayMode: "interactive",
  toggleDisplayMode: () => {
    const currentMode = get().displayMode;
    const newDisplayMode =
      currentMode === "interactive" ? "select" : "interactive";

    if (newDisplayMode === "interactive") {
      // Reset to defaults when switching to interactive mode
      get().resetToDefaults();
    } else {
      set({ displayMode: newDisplayMode });
    }
  },

  sectionClicked: false,
  setSectionClicked: (sectionClicked) => set({ sectionClicked }),

  contextMenuOpen: false,
  setContextMenuOpen: (contextMenuOpen) => set({ contextMenuOpen }),

  resetToDefaults: () =>
    set({
      displayMode: "interactive",
      selectedElement: null,
      editText: null,
      classNames: "",
      sectionClicked: false,
      contextMenuOpen: false,
    }),

  viewingVersionId: null,
  setViewingVersionId: (viewingVersionId) => set({ viewingVersionId }),
}));
